<template>
  <v-app-bar
    app
    color="white"
    elevation="1"
    height="70"
    fixed
    class="truecar-header"
  >
    <v-container class="header-container">
      <!-- Logo Section -->
      <div class="logo-section">
        <v-img
          :src="require('@/assets/img/logo.png')"
          alt="AutoSync Logo"
          max-height="80"
          max-width="120"
          contain
          class="logo-image"
          @click="goHome"
        ></v-img>
      </div>


      <!-- Spacer -->
      <v-spacer></v-spacer>

      <!-- Desktop Actions -->
      <div class="desktop-actions d-flex align-center">
        <v-btn
          text
          small
          @click="goToLogin"
          class="sign-in-btn mr-2"
        >
          Sign In
        </v-btn>
        <v-btn
          color="primary"
          small
          depressed
          @click="goToSignUp"
          class="sign-up-btn"
        >
          Sign Up
        </v-btn>
      </div>

    
    </v-container>

  </v-app-bar>
</template>

<script>
export default {
  name: 'PublicHeader',
  data() {
    return {
      drawer: false
    }
  },
  methods: {
    goHome() {
      this.$router.push('/')
      this.drawer = false
    },

    goToLogin() {
      this.$router.push('/login')
      this.drawer = false
    },

    goToSignUp() {
      this.$router.push('/register')
      this.drawer = false
    },

    goToNewCars() {
      // TODO: Implement new cars page
      console.log('Navigate to new cars')
      this.drawer = false
    },

    goToUsedCars() {
      this.$router.push('/inventory')
      this.drawer = false
    },

    goToInventory() {
      this.$router.push('/inventory')
      this.drawer = false
    },

    goToSellCar() {
      // TODO: Implement sell car page
      console.log('Navigate to sell car')
      this.drawer = false
    }
  }
}
</script>

<style scoped>
/* TrueCar Header */
.truecar-header {
  background: white !important;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  max-width: 1200px;
  height: 100%;
}

/* Logo Section */
.logo-section {
  display: flex;
  align-items: center;
}

.logo-image {
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.logo-image:hover {
  opacity: 0.8;
}

/* Navigation Menu */
.navigation-menu {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 40px;
}

.nav-btn {
  text-transform: none !important;
  font-weight: 500 !important;
  font-size: 0.875rem !important;
  color: #374151 !important;
  padding: 8px 16px !important;
  border-radius: 4px !important;
  min-width: auto !important;
  height: 36px !important;
}

.nav-btn:hover {
  background-color: #f3f4f6 !important;
  color: #111827 !important;
}

.nav-btn::before {
  background-color: transparent !important;
}

/* Desktop Actions */
.desktop-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sign-in-btn {
  text-transform: none !important;
  font-weight: 500 !important;
  font-size: 0.875rem !important;
  color: #374151 !important;
  padding: 8px 16px !important;
  border-radius: 4px !important;
  min-width: auto !important;
  height: 36px !important;
}

.sign-in-btn:hover {
  background-color: #f3f4f6 !important;
  color: #111827 !important;
}

.sign-in-btn::before {
  background-color: transparent !important;
}

.sign-up-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 0.875rem !important;
  color: white !important;
  background-color: #1976d2 !important;
  padding: 8px 20px !important;
  border-radius: 20px !important;
  min-width: auto !important;
  height: 36px !important;
  box-shadow: none !important;
}

.sign-up-btn:hover {
  background-color: #1565c0 !important;
}

.sign-up-btn::before {
  background-color: transparent !important;
}

/* Mobile Menu */
.mobile-menu-btn {
  color: #374151 !important;
}

/* Mobile Navigation Drawer */
.mobile-drawer {
  background: white !important;
}

.mobile-drawer .v-list-item {
  padding: 12px 20px !important;
  border-radius: 0 !important;
  margin: 0 !important;
}

.mobile-drawer .v-list-item:hover {
  background-color: #f3f4f6 !important;
  transform: none !important;
}

.mobile-drawer .v-list-item-title {
  font-weight: 500 !important;
  color: #374151 !important;
  font-size: 0.875rem !important;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .header-container {
    padding: 0 16px;
  }

  .navigation-menu {
    margin-left: 20px;
    gap: 4px;
  }

  .nav-btn {
    padding: 8px 12px !important;
  }
}

@media (max-width: 960px) {
  .header-container {
    padding: 0 16px;
  }

  .logo-image {
    max-height: 32px !important;
    max-width: 100px !important;
  }
}

@media (max-width: 600px) {
  .header-container {
    padding: 0 12px;
  }

  .logo-image {
    max-height: 78px !important;
    max-width: 90px !important;
  }
}
</style>
